import Vue from "vue"
import VueRouter from "vue-router"
import Layout from "@/layout/index.vue"
import Culture from "./culture"
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err
    }
  })
}
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        component: () => import("@/views/home/index.vue"),
      },
      // 资讯｜｜公告
      {
        path: "announcement",
        component: () => import("@/views/home/announcement.vue"),
      },
      // 公告详情
      {
        path: "home/ggDetail",
        component: () => import("@/views/education/detail.vue"),
      },
      {
        path: "guide",
        component: () => import("@/views/guide/index.vue"),
      },
      {
        path: "exhibition/list",
        component: () => import("@/views/exhibition/list.vue"),
      },
      // 预约办展
      {
        path: "exhibition/appointment",
        component: () => import("@/views/exhibition/appointment.vue"),
      },
      // 详情
      {
        path: "exhibition/detail",
        component: () => import("@/views/exhibition/detail.vue"),
      },
      // 藏品
      {
        path: "collection/list",
        component: () => import("@/views/collection/index.vue"),
      },
      // 藏品详情
      {
        path: "collection/detail",
        component: () => import("@/views/collection/detail.vue"),
      },
      // 研究
      {
        path: "study",
        component: () => import("@/views/study/index.vue"),
      },
      // 专著列表
      {
        path: "study/list",
        component: () => import("@/views/study/list.vue"),
      },
      // 专著详情
      {
        path: "study/detail",
        component: () => import("@/views/study/detail.vue"),
      },
      // 论文详情
      {
        path: "study/lunwen",
        component: () => import("@/views/study/lunwen.vue"),
      },
      // 社教
      {
        path: "education",
        component: () => import("@/views/education/list.vue"),
      },
      // 社教详情
      {
        path: "education/detail",
        component: () => import("@/views/education/detail.vue"),
      },
      // 关于
      {
        path: "about/dashiji",
        name:"dashiji",
        component: () => import("@/views/about/index.vue"),
      },
      {
        path: "about/honor",
        name: "zizhi",
        component: () => import("@/views/about/honor.vue"),
      },
      {
        path: "about/xgjq",
        name: "xgjq",
        component: () => import("@/views/about/xgjq.vue"),
      },
      // 详情
      {
        path: "about/detail",
        component: () => import("@/views/about/detail.vue"),
      },
      {
        path: "about/dsjDetail",
        component: () => import("@/views/about/dsjDetail.vue"),
      },
      // 搜索
      {
        path: "search",
        component: () => import("@/views/search/index.vue"),
      },
      // 藏品征集
      {
        path: "collect",
        component: () => import("@/views/collect/index.vue"),
      },
      // 留言板
      {
        path: "messageBoard",
        component: () => import("@/views/messageBoard/index.vue"),
      },
      ...Culture,
    ],
  },
]

const router = new VueRouter({
  routes,
  mode: "history",
  base: "/pc/",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 } // 每次跳转时滚动到顶部
  },
})

export default router
